import TelephoneActionHistory from "./telephone-action-history.vue";
import ApplyHistory from "./apply-history.vue";
import CirculationHistory from "./circulation-history.vue";
import RecordHistory from "./record-history.vue";
import VisitActionHistory from "./visit-action-history.vue";
import LegalUrgeHistory from "./legal-urge-history.vue";
import OutgoingWarehousingHistory from "./outgoing-warehousing-history.vue";
import RepayRecords from "./repay-records.vue";
import TeleWater from "./tele-water.vue";
/**
 * 组件
 */
export var components = {
    TelephoneActionHistory: TelephoneActionHistory,
    ApplyHistory: ApplyHistory,
    CirculationHistory: CirculationHistory,
    RecordHistory: RecordHistory,
    VisitActionHistory: VisitActionHistory,
    // VisitAnnex,
    RepayRecords: RepayRecords,
    TeleWater: TeleWater,
    LegalUrgeHistory: LegalUrgeHistory,
    OutgoingWarehousingHistory: OutgoingWarehousingHistory
};
/**
 * 历史纪录业务组合
 */
export var tabs = [
    // {
    //   label: '电催总结记录',
    //   name: "tele-water"
    // },
    {
        label: "电催行动记录",
        name: "telephone-action-history"
    },
    {
        label: "外访行动记录",
        name: "visit-action-history"
    },
    {
        label: "法务行动记录",
        name: "legal-urge-history"
    },
    {
        label: "流转记录",
        name: "circulation-history"
    },
    {
        label: "通话记录",
        name: "record-history"
    },
    {
        label: "申请记录",
        name: "apply-history"
    },
    {
        label: "出入库记录",
        name: "outgoing-warehousing-history"
    },
    {
        label: "回款记录",
        name: "repay-records"
    },
];
